// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"style_imgWrapper__UmsYV"};